import { Vendor, VendorACH, VendorInternationalWire } from './coach-payment-report.js';

export const getCoachACHPaymentOrNull = (vendor?: Vendor): VendorACH | null => {
  switch (vendor?.payment_accounts?.details.type) {
    case 'ACH':
      return vendor as VendorACH;
    default:
      return null;
  }
};

export const getCoachPaymentInternationalOrNull = (vendor?: Vendor): VendorInternationalWire | null => {
  switch (vendor?.payment_accounts?.details.type) {
    case 'INTERNATIONAL_WIRE':
      return vendor as VendorInternationalWire;
    default:
      return null;
  }
};

export const maskAllButLast4 = (value: string): string => {
  if (value.length <= 4) {
    return '*'.repeat(value.length);
  }

  return `${'*'.repeat(value.length - 4)}${value.slice(-4)}`;
};
